export default "<div class=\"dispatch-exutoire\">\n  {{DispatchExutoireInComponent}}\n</div>\n\n";